import AnnotationStore from "./annotation-store";
import ViralVariantStore from "./viral-variant-store";
import UserStore from "./user-store";
import GenomeStore from "./genome-store";
import { ApiClient } from "../api";
import DiscrepancyReportsStore from "./discrepancy-reports-store";
import CellBioStore from "./cell-bio-store";
import CatalogTreeStore from "./catalog-tree-store";

export default class RootStore {
  public api: ApiClient;

  public annotationStore: AnnotationStore;
  public viralVariantStore: ViralVariantStore;
  public userStore: UserStore;
  public _genomeListStore: GenomeStore;
  public _relatedGenomesStore: GenomeStore;
  public genomesStoreType: "genomes-page" | "related-genomes" = "genomes-page";
  public discrepancyReportsStore: DiscrepancyReportsStore;
  public cellBioStore: CellBioStore;
  public catalogTreeStore: CatalogTreeStore;

  constructor(data?: RootStore) {
    this.api = new ApiClient();

    this.annotationStore = new AnnotationStore(this.api, data?.annotationStore);
    this.viralVariantStore = new ViralVariantStore(this.api);
    this.userStore = new UserStore(this.api, data?.userStore);
    this._genomeListStore = new GenomeStore(this.api, this.userStore, data?._genomeListStore);
    this._relatedGenomesStore = new GenomeStore(
      this.api,
      this.userStore,
      data?._relatedGenomesStore
    );
    this.discrepancyReportsStore = new DiscrepancyReportsStore(
      this.api,
      data?.discrepancyReportsStore
    );
    this.cellBioStore = new CellBioStore(this.api, this.userStore, data?.cellBioStore);
    this.catalogTreeStore = new CatalogTreeStore(this.api, this.genomeStore);

    if (data) {
      this.api.ssrCookie = data.api.ssrCookie;
      this.api.ssrCookies = data.api.ssrCookies;
    }
  }

  get genomeStore(): GenomeStore {
    return this.genomesStoreType === "genomes-page"
      ? this._genomeListStore
      : this._relatedGenomesStore;
  }
}
